import { jsx as r, jsxs as g } from "react/jsx-runtime";
import { O as s, P as f, C as i, T as d, D as n, R as p, a as x } from "../../index-VfZ_jHkF.js";
import * as l from "react";
import { c as t } from "../../utils-BOFVZgHd.js";
const k = p, T = x, y = f, c = l.forwardRef(({ className: a, ...e }, o) => /* @__PURE__ */ r(
  s,
  {
    ref: o,
    className: t("fixed inset-0 z-50 bg-black/50 backdrop-blur-sm transition-all", a),
    ...e
  }
));
c.displayName = s.displayName;
const N = l.forwardRef(({ className: a, children: e, ...o }, m) => /* @__PURE__ */ g(y, { children: [
  /* @__PURE__ */ r(c, {}),
  /* @__PURE__ */ r(
    i,
    {
      ref: m,
      className: t(
        "fixed left-1/2 top-1/2 z-[51] grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-[var(--border)] p-6 shadow-lg duration-200 sm:rounded-lg dialog-content",
        a
      ),
      style: {
        backgroundColor: "var(--background)",
        color: "var(--foreground)"
      },
      ...o,
      children: e
    }
  )
] }));
N.displayName = i.displayName;
const D = ({ className: a, ...e }) => /* @__PURE__ */ r("div", { className: t("flex flex-col space-y-1.5 text-center sm:text-left", a), ...e });
D.displayName = "DialogHeader";
const b = l.forwardRef(({ className: a, ...e }, o) => /* @__PURE__ */ r(
  d,
  {
    ref: o,
    className: t("text-lg font-semibold leading-none tracking-tight", a),
    ...e
  }
));
b.displayName = d.displayName;
const u = l.forwardRef(({ className: a, ...e }, o) => /* @__PURE__ */ r(
  n,
  {
    ref: o,
    className: t("text-sm text-[var(--muted-foreground)]", a),
    ...e
  }
));
u.displayName = n.displayName;
export {
  k as Dialog,
  N as DialogContent,
  u as DialogDescription,
  D as DialogHeader,
  b as DialogTitle,
  T as DialogTrigger
};
//# sourceMappingURL=dialog.js.map
